<template>
  <div class="m-portlet m-portlet--mobile m-portlet--body-progress-">
    <div class="m-portlet__head filters" style="padding: 1em 2.2rem;">
      <div class="m-portlet__head-toolbar">
        <button
          id="anchorMe"
          data-toggle="tooltip"
          data-placement="top"
          :title="labels.export_products_tooltip"
          class="btn btn-primary m-btn m-btn--icon m-btn--wide m-btn--sm m--margin-right-10"
          :class="exportActionDisabled"
          :disabled="exportCount === 0"
          @click="initialiseExport"
        >
          <span>
            <span>{{ labels.export_all | capitalize }} ({{ exportCount }})</span>
          </span>
        </button>
        <a
          href="#"
          data-toggle="tooltip"
          data-placement="top"
          :title="labels.compare_products_tooltip"
          class="btn btn-primary m-btn m-btn--icon m-btn--wide m-btn--sm m--margin-right-10"
          :class="compareBtnDisabled"
          :disabled="compareBtnDisabled === 'disabled'"
          @click="openCompareView"
        >
          <span>
            <span>{{ labels.compare_products | capitalize }}</span>
          </span>
        </a>
        <button
          class="btn btn-secondary m-btn m-btn--icon m-btn--sm m--margin-right-10"
          @click="toggleSelectAll"
        >
          <span>
            <span>{{ selectAllLabel | capitalize }}</span>
          </span>
        </button>

        <a href="#" class="btn btn-secondary m-btn m-btn--icon m-btn--sm m--margin-right-10" @click.prevent="goToIngredientsView" :disabled="isVuesDisabled" :class="isVuesDisabled">
          <span>
            <span>{{ labels.view_ingredients | capitalize }}</span>
          </span>
        </a>
        <a href="#" class="btn btn-secondary m-btn m-btn--icon m-btn--sm m--margin-right-10" @click.prevent="goToRolesView" :disabled="isVuesDisabled" :class="isVuesDisabled">
          <span>
            <span>{{ labels.view_roles | capitalize }}</span>
          </span>
        </a>
        <a href="#" class="btn btn-secondary m-btn m-btn--icon m-btn--sm m--margin-right-10" @click.prevent="goToRelatedIncisView" :disabled="isVuesDisabled" :class="isVuesDisabled">
          <span>
            <span>{{ labels.view_related_incis | capitalize }}</span>
          </span>
        </a>
      </div>
    </div>
    <div class="m-portlet__body" id="hitsBody">
      <div class="m-portlet__body-progress"></div>
      <div class="m-portlet__body" m-hidden-height="345">
        <div id="hits"></div>
      </div>
    </div>

    <div
      class="modal fade"
      :class="{'show': compareIsActive }"
      id="m_modal_product_compare"
      tabindex="-1"
      role="dialog"
      :style="modalStyle"
    >
      <div class="modal-dialogue" role="document" style="max-width: auto; margin: 2rem;">
        <div class="modal-content" v-if="!compareBtnDisabled && compareIsActive">
          <div class="modal-header">
            <h5 class="modal-title"></h5>
            <button
              id="formModalClose"
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="compareIsActive = 0"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-lg-6">
                <PreviewProduct :productId="selectedProductIds[0]" :key="'product_' + 0"></PreviewProduct>
              </div>
              <div class="col-lg-6">
                <PreviewProduct :productId="selectedProductIds[1]" :key="'product_' + 1"></PreviewProduct>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop fade show" v-show="compareIsActive"></div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import XLSX from 'xlsx';
import Swal from 'sweetalert2';

// Initialise algolia
import * as algoliasearch from 'algoliasearch';

// Components
import PreviewProduct from '../Preview/PreviewProduct';

const moment = require('moment');

const client = algoliasearch(
  process.env.ALGOLIA_APP_ID,
  process.env.ALGOLIA_SEARCH_KEY,
);
const productIndex = client.initIndex(`${process.env.ENV_SHORTNAME}_products`);

// Excel order:
// Theme – Segmentations – Brand – Collection – Produit Name – Claims (informations du pack primaire (efficacité et sécurité) ) -  Claims (les informations internet (l’efficacité et sécurité)) – actifs revendiqués – Brevet – Rôle – INCI – Statut – Catégorie – Cible – Zone d’application – Types de peau – Types de pack – Texturothèque – Statut – Contenance du pack – Circuit de distribution – Pays de distribution – Fabriqué en France – Commercialisé – Archivé
const headers = [
  'themes', // A
  'productLeaders', // Brand – Collection – Produit Name ; -> * For each theme have to get a list of their products (local storage), for each product in the list have to make a request (Algolia)
  'subSegmentation', // seg parent - seg enfant1; seg parent seg enfant2; -> * We have parent segs & segs in Algolia but we don't know which seg belongs to which parent seg. For each parent seg can do an internal request to find their child
  'verbatimConso',
  'brandName',
  'collectionName',
  'name', // H
  'claimsEfficiency-efficiency_primary_pack_front',
  'claimsEfficiency-efficiency_primary_pack_back',
  'claimsEfficiency-efficiency_secondary_pack_front',
  'claimsEfficiency-efficiency_secondary_pack_back',
  'claimsEfficiency-efficiency_on_brand_website',
  'claimsEfficiency-efficiency_on_other_source', // O
  'claimsSecurity-security_primary_pack_front',
  'claimsSecurity-security_primary_pack_back',
  'claimsSecurity-security_secondary_pack_front',
  'claimsSecurity-security_secondary_pack_back',
  'claimsSecurity-security_on_brand_website',
  'claimsSecurity-security_on_other_source', // U
  'specificMention',
  'claimedIngredients', // ingredient revendiqué 1 (X%); ingredient revendiqué 2 (X%)
  'ingredientRolesDescription', // X role 1 (description du role), role 2 (description du role)
  'claimedIngredientRoles', // Y ingredient 1 (role1, role2); ingredient 2 (role 2, role 3)
  'claimedRelatedINCI', // Z inci1; inci2 TODO change to relatedINCI
  'claimedIngredientWithRelatedINCI', // AA COLUMN BREAK
  'ingredientsNotClaimed', // ingredient 1 (X%); ingredient 2 (X%),
  'notClaimedRolesDescription', // role 1 (description du role), role 2 (description du role),
  'notClaimedIngredientRoles', // ingredient 1 (role1, role2); ingredient 2 (role 2, role 3)
  'notClaimedRelatedINCI',
  'notClaimedIngredientWithRelatedINCI', // COLUMN BREAK
  'patents',
  'patentIngredients', // AH ingredient 1 (brevet1); ingredient 2 (brevet 2); ingredient 3 (brevet 2)
  'patentRoles',
  'listINCI', // ALL IN UPPERCASE
  'typeName',
  'categoryName',
  'targets',
  'areas',
  'typeSkins',
  'typePacks',
  'textureName',
  'texturothequeName',
  'packageCapacities',
  'tinted',
  'spf',
  'uva',
  'perfume',
  'perfumeClaimed',
  'bio',
  'distributionChannels',
  'countryDistribution',
  'commercialized',
  'archived',
];
const cols = [
  { width: 25 }, // A
  { width: 50 },
  { width: 50 }, // C
  { width: 50 },
  { width: 15 }, // F
  { width: 50 },
  { width: 50 },
  { width: 50 },
  { width: 50 }, // K
  { width: 50 },
  { width: 50 },
  { width: 50 },
  { width: 50 },
  { width: 50 },
  { width: 50 },
  { width: 50 },
  { width: 50 },
  { width: 50 }, // T
  { width: 50 },
  { width: 15 },
  { width: 50 }, // WW
  { width: 50 },
  { width: 50 }, // Y
  { width: 50 }, // Z
  { width: 50 }, // AA
  { width: 50 },
  { width: 50 },
  { width: 50 },
  { width: 50 },
  { width: 50 },
  { width: 50 },
  { width: 50 },
  { width: 50 }, // AI
  { width: 50 },
  { width: 15 },
  { width: 15 }, // AL
  { width: 15 },
  { width: 25 },
  { width: 25 },
  { width: 15 },
  { width: 15 },
  { width: 15 },
  { width: 15 },
];

export default {
  components: {
    PreviewProduct,
  },
  props: ['results', 'search', 'canExport'],
  data() {
    return {
      exporting: false,
      compareIsActive: 0,
      productList: [],
      totalHits: 0,
      exportLabel: '',
      listProductIds: [],
      listProductLeadersIds: [],
      listProductLeaders: [],
      listThemesProductleader: [],
    };
  },
  computed: {
    ...mapState({
      labels: (store) => store.labels,
      selectedProductIds: (store) => store.products.selectedProductIds,
      allSelected: (store) => store.products.allSelected,
      themes: (store) => store.crudData.cruds.themes,
    }),
    ...mapGetters(['getResourceValue']),
    compareBtnDisabled() {
      return this.selectedProductIds.length !== 2 || this.allSelected
        ? 'disabled'
        : '';
    },
    isVuesDisabled() {
      return this.selectedProductIds.length > 0 ? 'disabled' : false;
    },
    exportActionDisabled() {
      return !this.exportCount ? 'disabled' : '';
    },
    modalStyle() {
      return this.compareIsActive
        ? 'overflow-y: scroll; display: block;'
        : 'display: none;';
    },
    excelHeaders() {
      const headerLabels = [];
      headers.map((header) => {
        headerLabels.push(
          this.labels[header] || this.labels.productFilters[header],
        );
      });
      return headerLabels;
    },
    exportCount() {
      if (this.allSelected) {
        return this.results - this.selectedProductIds.length;
      }
      return this.selectedProductIds.length;
    },
    selectAllLabel() {
      return this.allSelected || this.selectedProductIds.length
        ? this.labels.clear_selection
        : this.labels.select_all;
    },
  },
  mounted() {
    const my = this;
    $('[data-toggle="tooltip"]').tooltip({ trigger: 'hover' });
    $('#m_modal_product_compare').on('click', function (event) {
      if (this === event.target) {
        my.compareIsActive = 0;
      }
    });
  },
  methods: {
    ...mapActions('products', [
      'setSelectedProducts',
      'toggleAllSelected',
      'toggleCheckBoxes',
      'storeLastQueryURL',
      'storeLastQuery',
    ]),
    openCompareView() {
      this.storeLastQueryURL(this.search.helper.lastResults._rawResults);
      this.storeLastQuery(this.search.helper.state);
      this.compareIsActive = 1;
    },
    async initialiseExport() {
      try {
        this.triggerAlert();
        this.exporting = true;
        this.totalHits = this.exportCount;
        productIndex.clearCache();

        if (!this.allSelected) {
          this.listProductIds = this.selectedProductIds;
        } else {
          await this.setListProductIdsFromSearch();
        }

        const productsSearchResult = await this.getAllProductsByIds();
        const productsClaimsSearchResult = await this.getAllClaimsByProductsIds();
        // get all the product leader ids
        this.getProductLeadersId();
        const productLeadersSearchResult = await this.getAllProductLeaders();

        this.setThemesProductLeaders(productLeadersSearchResult);

        productsSearchResult.hits.forEach((productHit) => {
          this.addClaimsData(productsClaimsSearchResult, productHit);
          this.addProductLeaderToProduct(productHit);
          this.addIngredientData(productHit);
          this.addPatentIngredientData(productHit);
        });

        // Send directly to full product list
        this.productList = productsSearchResult.hits;
        this.exportAction();
      } catch (e) {
        console.log(e);
      }

      this.exporting = false;
      const my = this;
      setTimeout(() => {
        my.totalHits = 0;
        my.productList = [];
        Swal.close();
      }, 700);
    },
    setThemesProductLeaders(productLeadersSearchResult) {
      try {
        this.listThemesProductleader = [];
        this.themes.forEach((theme) => {
          const tempListThemesProductleader = [];
          theme.product_leaders.forEach((productLeaderId) => {
            productLeadersSearchResult.hits.forEach((productLeaderData) => {
              if (productLeaderId == productLeaderData.productId) {
                tempListThemesProductleader.push(
                  `${productLeaderData.brandName
                  } - ${
                    productLeaderData.collectionName
                  } - ${
                    productLeaderData.name}`,
                );
              }
            });
          });
          this.listThemesProductleader[
            theme.theme_id
          ] = tempListThemesProductleader;
        });
      } catch (e) {
        console.log('setThemesProductLeaders', e);
      }
    },
    getProductLeadersId() {
      this.themes.forEach((theme) => {
        theme.product_leaders.forEach((productLeaderId) => {
          if (this.listProductLeadersIds.indexOf(productLeaderId) == -1) {
            this.listProductLeadersIds.push(productLeaderId);
          }
        });
      });
    },
    addClaimsData(productsClaimsSearchResult, productHit) {
      const result = productsClaimsSearchResult.hits.filter((obj) => obj.productId === productHit.productId);

      if (result) {
        result.forEach((claim) => {
          claim.hasOwnProperty('claimsEfficiency')
            ? (productHit.claimsEfficiency = claim.claimsEfficiency)
            : null;
          claim.hasOwnProperty('claimsSecurity')
            ? (productHit.claimsSecurity = claim.claimsSecurity)
            : null;
        });
      }
    },
    getFacetFiltersSearchFromList(list, facetName) {
      const facetFilters = [];

      list.forEach((item) => {
        facetFilters.push(`${facetName}:${item}`);
      });

      return facetFilters;
    },
    async getAllProductsByIds() {
      try {
        const productsSearchResult = await productIndex.search({
          query: '',
          distinct: true,
          page: 0,
          hitsPerPage: 1000,
          facetFilters: [
            this.getFacetFiltersSearchFromList(this.listProductIds, 'productId'),
          ],
        });

        return productsSearchResult;
      } catch (err) {
        console.log(err);
      }
    },
    async getAllClaimsByProductsIds() {
      try {
        const productsClaimsSearchResult = await productIndex.search({
          query: '',
          distinct: false,
          page: 0,
          hitsPerPage: 1000,
          facetFilters: [
            ['isClaim:true'],
            this.getFacetFiltersSearchFromList(this.listProductIds, 'productId'),
          ],
        });

        return productsClaimsSearchResult;
      } catch (err) {
        console.log(err);
      }
    },
    async exportAction() {
      // /* convert state to workbook */
      const ws = XLSX.utils.aoa_to_sheet(
        await this.createXLSData(this.productList),
      );

      /* Set worksheet sheet to "wide" */
      ws['!margins'] = {
        left: 1.0,
        right: 1.0,
        top: 1.0,
        bottom: 1.0,
        header: 0.5,
        footer: 0.5,
      };
      ws['!cols'] = cols;

      let i;
      for (i in ws) {
        /* all keys that do not begin with "!" correspond to cell addresses */
        if (i.indexOf('!') === -1) {
          ws[i].s = {
            alignment: {
              wrapText: 1, // any truthy value here
            },
          };
        }
      }
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'SheetJS');
      const fileName = `Export produits - ${moment().format('DD/MM/YYYY')}.xlsx`;
      /* generate file and send to client */
      XLSX.writeFile(wb, fileName);
    },
    toggleSelectAll() {
      this.allSelected || this.selectedProductIds.length
        ? this.toggleAllSelected(false)
        : this.toggleAllSelected(true);
      this.toggleCheckBoxes(this.allSelected);
      this.setSelectedProducts(null);
    },
    async createXLSData(products) {
      const my = this;
      try {
        const data = [this.excelHeaders];
        let productValue;
        await products.map((product) => {
          async function getData() {
            const row = [];
            headers.map((header) => {
              productValue = product[header];
              if (Array.isArray(productValue)) {
                row.push(productValue.join('; '));
              } else if (
                header.indexOf('claimsEfficiency') !== -1
                || header.indexOf('claimsSecurity') !== -1
              ) {
                const claimKey1 = header.split('-')[0];
                const claimKey2 = header.split('-')[1];
                const claimValue = product.hasOwnProperty(claimKey1)
                    && product[claimKey1][claimKey2]
                  ? product[claimKey1][claimKey2]
                  : '';

                row.push(claimValue);
              } else if (typeof productValue === 'boolean') {
                row.push(my.labels[productValue]);
              } else {
                row.push(productValue);
              }
            });
            return data.push(await row);
          }
          getData();
        });
        return await data;
      } catch (err) {
        console.log(err);
      }
    },
    async getProductIds(query, searchParameters) {
      try {
        const productsIdSearchResult = await productIndex.search(
          query,
          searchParameters,
        );

        if (productsIdSearchResult) {
          productsIdSearchResult.hits.forEach((productIdHit) => {
            if (
              !this.selectedProductIds
              || this.selectedProductIds.indexOf(productIdHit.productId) === -1
            ) {
              this.listProductIds.push(productIdHit.productId);
            }
          });

          // If total hits exceed 1000 call request again
          if (
            productsIdSearchResult.nbHits
            > (productsIdSearchResult.page + 1)
              * productsIdSearchResult.hitsPerPage
          ) {
            searchParameters.page = productsIdSearchResult.page + 1;
            await this.getProductIds(query, searchParameters);
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
    async getAllProductIdsFromSearch() {
      try {
        const productsIdSearchResult = await productIndex.search({
          query: '',
          distinct: true,
          page: 0,
          hitsPerPage: 1000,
          facetFilters: [
            this.getFacetFiltersSearchFromList(this.listProductIds, 'productId'),
          ],
        });

        return productsSearchResult;
      } catch (err) {
        console.log(err);
      }
    },
    async setListProductIdsFromSearch() {
      if (
        this.search.helper
        && this.search.helper.lastResults
        && this.search.helper.lastResults._rawResults.length
      ) {
        // Get the last result object
        const lastResult = this.search.helper.lastResults._rawResults[0];
        if (lastResult) {
          const queryArray = lastResult.params.split('&');
          const query = queryArray[0].split('=')[1];
          queryArray.splice(0, 2, 'hitsPerPage=1000');

          const searchParameters = await this.createParams(queryArray, 0);
          await this.getProductIds(decodeURIComponent(query), searchParameters);
        }
      }
    },
    async createParams(params) {
      try {
        const searchParameters = {
          attributesToRetrieve: ['productId'],
        };
        params.map((param) => {
          const splitParam = param.split('=');
          const key = decodeURIComponent(splitParam[0]);
          const value = decodeURIComponent(splitParam[1]);

          if (key === 'hitsPerPage') {
            searchParameters[key] = 1000;
          } else if (key === 'page') {
            searchParameters[key] = 0;
          } else {
            searchParameters[key] = value;
          }
        });
        return await searchParameters;
      } catch (err) {
        console.log(err);
      }
    },
    triggerAlert() {
      Swal({
        title: this.labels.export_in_progress,
        showConfirmButton: false,
        allowEscapeKey: false,
        allowOutsideClick: false,
        onOpen() {
          Swal.showLoading();
        },
      });
    },
    async getAllProductLeaders() {
      try {
        const productLeadersResultSearch = await productIndex.search({
          query: '',
          distinct: true,
          page: 0,
          hitsPerPage: 1000,
          facets: '["productId"]',
          facetFilters: [
            this.getFacetFiltersSearchFromList(
              this.listProductLeadersIds,
              'productId',
            ),
          ],
          attributesToRetrieve: [
            'brandName',
            'productId',
            'collectionName',
            'name',
          ],
        });

        return productLeadersResultSearch;
      } catch (err) {
        console.log(err);
      }
    },
    async getProductLeadersByTheme(productObj) {
      try {
        const query = [];
        productObj.themes.forEach((theme) => {
          this.getResourceValue(
            theme,
            'name',
            'themes',
            'product_leaders',
          ).forEach((productId) => {
            query.push(`"productId:${productId}"`);
          });
        });
        return query;
      } catch (err) {
        console.log(err);
      }
    },
    async addProductLeaderToProduct(productObj) {
      if (productObj.themesId) {
        try {
          const productLeaderData = [];
          productObj.themesId.forEach((themeId) => {
            if (this.listThemesProductleader[themeId]) {
              this.listThemesProductleader[themeId].forEach((productLeader) => {
                if (productLeaderData.indexOf(productLeader) == -1) {
                  if (productObj.themesId.length > 1) {
                    const myTheme = this.themes.find((theme) => theme.theme_id === themeId);
                    productLeaderData.push(`${productLeader} (${myTheme.name})`);
                  } else {
                    productLeaderData.push(productLeader);
                  }
                }
              });
            }
          });
          productObj.productLeaders = productLeaderData.join('; ');
        } catch (err) {
          console.log(err);
        }
      }
    },
    addPatentIngredientData(productObj) {
      if (productObj.patentsV2) {
        const ing = [];
        const obj = {};
        const patents = [];
        const objRoles = {};
        const roles = [];

        productObj.patentsV2.forEach((patentItem) => {
          if (patentItem.ingredients) {
            patentItem.ingredients.forEach((ingredientItem) => {
              if (ing.indexOf(ingredientItem.name) === -1) {
                ing.push(ingredientItem.name);
              }
              if (!Object.prototype.hasOwnProperty.call(obj, ingredientItem.name)) {
                obj[ingredientItem.name] = [];
              }
              obj[ingredientItem.name].push(patentItem.name);
            });
          }

          if (patentItem.roles) {
            patentItem.roles.forEach((roleItem) => {
              if (roles.indexOf(roleItem.name) === -1) {
                roles.push(roleItem.name);
              }
              if (!Object.prototype.hasOwnProperty.call(objRoles, roleItem.name)) {
                objRoles[roleItem.name] = [];
              }

              objRoles[roleItem.name].push(patentItem.name);
            });
          }

          let patent = patentItem.name;
          if (patentItem.number) {
            patent += ` (${patentItem.number})`;
          }
          patents.push(patent);
        });

        // this override the default behavior base on the header definition
        productObj.patents = patents;

        const myString = ing
          .map((element) => `${element} (${obj[element].join(',')})`)
          .join('; ');

        productObj.patentIngredients = myString;

        const myStringRole = roles
          .map((element) => `${element} (${objRoles[element].join(',')})`)
          .join('; ');

        productObj.patentRoles = myStringRole;
      }
    },
    async addIngredientData(productObj) {
      if (productObj.hasOwnProperty('ingredientsV2')) {
        // Create empty object for claimed ingredients
        productObj.claimedIngredients = [];
        productObj.claimedIngredients = [];
        productObj.ingredientRolesDescription = [];
        productObj.claimedIngredientRoles = [];
        productObj.claimedRelatedINCI = [];
        productObj.claimedIngredientWithRelatedINCI = [];

        // Create empty object for NON claimed ingredients
        productObj.ingredientsNotClaimed = [];
        productObj.notClaimedRolesDescription = [];
        productObj.notClaimedIngredientRoles = [];
        productObj.notClaimedRelatedINCI = [];
        productObj.notClaimedIngredientWithRelatedINCI = [];

        productObj.ingredientsV2.forEach((ingredient) => {
          try {
            if (ingredient.roles) {
              ingredient.roles.forEach((role) => {
                const description = this.getResourceValue(
                  role.name,
                  'name',
                  'roles',
                  'description',
                );

                if (ingredient.claimed) {
                  productObj.ingredientRolesDescription.push(
                    `${role.name} ${description ? `(${description})` : ''}`,
                  );
                } else {
                  productObj.notClaimedRolesDescription.push(
                    `${role.name} ${description ? `(${description})` : ''}`,
                  );
                }
              });
            }

            if (ingredient.claimed) {
              let { name } = ingredient;

              if (ingredient.percentage !== null) {
                name += ` (${ingredient.percentage}%)`;
              }
              productObj.claimedIngredients.push(name);
              if (ingredient.roles) {
                const rolesName = ingredient.roles.map((role) => role.name);
                productObj.claimedIngredientRoles.push(
                  `${ingredient.name} (${rolesName.join(', ')})`,
                );
              }
              if (ingredient.related_inci) {
                productObj.claimedRelatedINCI.push(ingredient.related_inci);
                productObj.claimedIngredientWithRelatedINCI.push(
                  `${ingredient.name} (${ingredient.related_inci})`,
                );
              }
            } else {
              let { name } = ingredient;

              if (ingredient.percentage !== null) {
                name += ` (${ingredient.percentage}%)`;
              }
              productObj.ingredientsNotClaimed.push(name);

              if (ingredient.roles) {
                const rolesName = ingredient.roles.map((role) => role.name);
                productObj.notClaimedIngredientRoles.push(
                  `${ingredient.name} (${rolesName})`,
                );
              }
              if (ingredient.related_inci) {
                productObj.notClaimedRelatedINCI.push(ingredient.related_inci);
                productObj.notClaimedIngredientWithRelatedINCI.push(
                  `${ingredient.name} (${ingredient.related_inci})`,
                );
              }
            }
          } catch (err) {
            console.log(err);
          }
        });
      }
    },
    goToIngredientsView() {
      this.storeLastQuery(this.search.helper.state);
      this.storeLastQueryURL(this.search.helper.lastResults._rawResults);

      this.$router.push({ name: 'IngredientsTable' });
    },
    goToRolesView() {
      this.storeLastQuery(this.search.helper.state);
      this.storeLastQueryURL(this.search.helper.lastResults._rawResults);

      this.$router.push({ name: 'RolesTable' });
    },
    goToRelatedIncisView() {
      this.storeLastQuery(this.search.helper.state);
      this.storeLastQueryURL(this.search.helper.lastResults._rawResults);

      this.$router.push({ name: 'RelatedIncisTable' });
    },
  },
};
</script>

<style>
#hitsBody {
  padding: 0.2em;
}
ol {
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  padding: 0;
}
.hit {
  border-bottom: 1px solid #eae9f2;
  padding: 10px 0;
  margin-top: 10px;
}

.hit-image {
  width: 170px;
}
.thumbnail-image-wrapper {
  text-align: center;
  padding: 5px;
}
.thumb-img {
  max-width: 100%;
}
.ais-Hits-item {
  width: 20%;
  margin: 0 2em 0;
}
.btn-primary.disabled {
  background-color: #9699a2 !important;
  pointer-events: none;
  border: none;
  color: #f0f0f0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Products/AllProducts/Results.vue